import React from 'react';
import { Form } from 'react-bootstrap';

import { CreateUpdateExamDtoSellDocumentTypeEnum } from '../../../common/spdCore/autogenerated/spdApiClient';
import FormRow from '../../../app/components/FormRow';

interface SellDocumentTypeSelectorProps {
  value: CreateUpdateExamDtoSellDocumentTypeEnum | undefined;
  onChange: (
    sellDocumentType: CreateUpdateExamDtoSellDocumentTypeEnum | undefined,
  ) => void;
}

export const SellDocumentTypeSelector: React.FC<
  SellDocumentTypeSelectorProps
> = ({ value, onChange }) => {
  return (
    <FormRow controlId="sellDocumentType" label="Typ dokumentu sprzedaży">
      <Form.Select
        value={value || ''}
        onChange={e =>
          onChange(
            (e.target.value as CreateUpdateExamDtoSellDocumentTypeEnum) || null,
          )
        }
      >
        <option value=""></option>
        {Object.values(CreateUpdateExamDtoSellDocumentTypeEnum).map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </Form.Select>
    </FormRow>
  );
};
